import React from "react";
import { DetailedPaymentPrefUnionObjectType } from "../../common/types";
import { PaymentPrefDisplayCardContainer } from "../PaymentPrefDisplayCardContainer";
import { getPaymentMethodIconType } from "../PaymentPrefDisplayCardContainer/utils";
import { PreviewPaymentPrefDisplay } from "../PreviewPaymentPrefDisplay";

export type PreviewPaymentPrefDisplayCardProps = {
  paymentPref: DetailedPaymentPrefUnionObjectType;
};

export const PreviewPaymentPrefDisplayCard: React.FC<PreviewPaymentPrefDisplayCardProps> = ({
  paymentPref,
}: PreviewPaymentPrefDisplayCardProps) => {
  const iconType = getPaymentMethodIconType(paymentPref);

  return (
    <PaymentPrefDisplayCardContainer iconType={iconType}>
      <PreviewPaymentPrefDisplay paymentPref={paymentPref} />
    </PaymentPrefDisplayCardContainer>
  );
};
